import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import appConfig from '@/config'
import { checker } from '@/utils/updateChecker'
import { lowPriorityAsyncCall } from '@/utils';
import { isServe, isBuild, isProd } from '@/env'
import VConsole from 'vconsole';
import '@/scripts'
import "@/hooks/useTrack";
import '@/hooks/usePWA'
import '@/app'
import '@/assets/main.scss'
import 'virtual:svg-icons-register'


if (isServe || (isBuild && !isProd)) {
  new VConsole();
}

if (isBuild && !localStorage._checker) {
  lowPriorityAsyncCall(() => {
    checker.start()
  })
}

dayjs.extend(utc);
dayjs.extend(timezone); // 使用时区插件
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);

document.title = appConfig.siteName
